import { observer } from "mobx-react-lite";
import { Colors } from "../../../utils/colors";
import { PairComparison } from "./PairComparison";
import { PartnerComparison } from "./PartnerComparison";
import { AllPlayersComparison } from "./AllPlayersComparison";
import { useMatchDetailsStore } from "../../../stores/StoreContext";

export const ComparisonSection = observer(() => {
  const matchDetailsStore = useMatchDetailsStore();

  const options = [
    { key: "pair", label: "Pair" },
    { key: "partner", label: "Partner" },
    { key: "allPlayers", label: "All Players" },
  ] as const;

  return (matchDetailsStore.matchClutchStats?.playerStatistics?.length ?? 0) >
    0 ? (
    <div
      style={{
        paddingLeft: 15,
        paddingRight: 15,
        marginTop: 20,
        paddingTop: 30,
        paddingBottom: 30,
        backgroundColor: Colors.green,
        width: "100%",
        borderRadius: 20,
        marginBottom: 20,
      }}>
      {/* Segmented Control */}
      <div
        style={{
          display: "flex",
          backgroundColor: Colors.lightGreen,
          borderRadius: 10,
          position: "relative",
          width: "100%",
          margin: "0 auto",
        }}>
        {options.map((option) => (
          <button
            key={option.key}
            onClick={() =>
              matchDetailsStore.setCurrentComparisonTab(option.key)
            }
            style={{
              flex: 1,
              padding: "14px 0px",
              border: "none",
              borderRadius: 10,
              backgroundColor:
                matchDetailsStore.currentComparisonTab === option.key
                  ? Colors.background
                  : Colors.lightGreen,
              color:
                matchDetailsStore.currentComparisonTab === option.key
                  ? Colors.black
                  : Colors.white, // Light white for unselected
              fontSize: 14,
              fontWeight: 500,
              cursor: "pointer",
              transition: "all 0.2s ease",
              position: "relative",
              zIndex:
                matchDetailsStore.currentComparisonTab === option.key ? 2 : 1,
              minWidth: 80,
              textAlign: "center",
            }}>
            {option.label}
          </button>
        ))}
      </div>
      {matchDetailsStore.currentComparisonTab === "pair" && <PairComparison />}

      {matchDetailsStore.currentComparisonTab === "partner" && (
        <PartnerComparison />
      )}
      {matchDetailsStore.currentComparisonTab === "allPlayers" && (
        <AllPlayersComparison />
      )}
    </div>
  ) : null;
});
